import { Box, Container, Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { API } from '../../../global/config/api';
import { useServerCall } from '../../../global/helpers/hooks';
import { BaseHeader, XsTableView } from '../../../global/ui';
import { ICallRow } from '../../../swagger/external';
import { TColumnExt } from '../../../global/types/types';
import CallsStore from './CallsStore';

const formatDate = (dateStr?: string): string => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
};

const columns: TColumnExt<ICallRow>[] = [
  { Header: 'calls.col_code_ext', accessor: 'code_ext', width: 120 },
  { Header: 'calls.col_name_ext', accessor: 'name_ext', width: 220 },
  {
    Header: 'calls.col_valid_from',
    accessor: 'valid_from',
    width: 120,
    Cell: ({ valid_from }: Partial<ICallRow>) => <span>{formatDate(valid_from)}</span>
  },
  {
    Header: 'calls.col_valid_to',
    accessor: 'valid_to',
    width: 120,
    Cell: ({ valid_to }: Partial<ICallRow>) => <span>{formatDate(valid_to)}</span>
  }
];

function CallsList() {
  const { t } = useTranslation();
  const history = useHistory();

  const callsCall = useServerCall<object, { rows: ICallRow[] }>({
    key: 'calls_list',
    mode: 'auto',
    request: { method: 'POST', url: API.calls(), data: {} },
    queryOptions: { refetchOnWindowFocus: false },
    onSuccess: (response) => {
      const rows = response.data?.rows ?? [];
      CallsStore.setListData(rows);
    }
  });

  const tableData = {
    rows: CallsStore.listData,
    totalRows: CallsStore.listData.length
  };

  return (
    <>
      <BaseHeader />
      <Container maxWidth='lg'>
        <Grid container direction='column'>
          <Grid item>
            <Box pt={2} pb={2}>
              <Typography variant='h4'>{t('calls.title')}</Typography>
            </Box>
          </Grid>
          <Grid item>
            <Typography variant='body2'>{t('calls.subtitle')}</Typography>
          </Grid>
        </Grid>
        <Box pt={2}>
          <Grid container>
            <Grid item xs={12}>
              <Box pt={1}>
                <XsTableView<ICallRow>
                  name='calls_table'
                  control='client'
                  columns={columns}
                  data={tableData}
                  pagination
                  initState={{ pageSize: 20 }}
                  loading={callsCall.isPending}
                  onRowClick={(row) => history.push(`/call?id=${row.ID}`)}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default observer(CallsList);
